/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_HintInputs */

const cs_contacts_hint = /** @type {(inputs: Contacts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail, telefon a další kanály.`)
};

const en_contacts_hint = /** @type {(inputs: Contacts_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email, phone and other channels.`)
};

/**
* | output |
* | --- |
* | "Email, phone and other channels." |
*
* @param {Contacts_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_hint = /** @type {((inputs?: Contacts_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_hint(inputs)
	return cs_contacts_hint(inputs)
});